<div mat-dialog-content>
    <h4>{{data.message}}</h4>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="accent" [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</div>
